import * as React from 'react';

export const useEditAddModal = () => {
  const [modalOpen, setModalOpen] = React.useState(false);
  const [currentId, setCurrentId] = React.useState('');
  const onEdit = React.useCallback(
    (id: string) => {
      setCurrentId(id);
      setModalOpen(true);
    },
    [setCurrentId, setModalOpen],
  );
  const onAdd = React.useCallback(() => {
    setCurrentId('');
    setModalOpen(true);
  }, [setCurrentId, setModalOpen]);

  return { modalOpen, setModalOpen, currentId, setCurrentId, onEdit, onAdd };
};
